import React from 'react';
import { Box } from '@mui/material';
import QualityGateDocuments from './QualityGateDocuments';

export default () => {
    return (
        <>
            <Box>
                <QualityGateDocuments isIncomplete={true} />
            </Box>
            <Box>
                <QualityGateDocuments isIncomplete={false} />
            </Box>
        </>
    );
};
